import React, { Component } from 'react';
import Select from 'react-select';

export default class CustomSelectWithValues extends Component {
  handleChange = values => {
    let value;
    if (values instanceof Array || this.props.isMulti) {
      value = values
        ? values.map(val => {
            return val.value;
          })
        : [];
    } else {
      value = values ? values.value : '';
    }
    if (this.props.onChange) {
      this.props.onChange(this.props.name, value);
    }
    if (this.props.onChangeValue) {
      this.props.onChangeValue([this.props.name], value);
    }
    if (this.props.onChangeOption) {
      this.props.onChangeOption(this.props.setFieldValue, this.props.formValues, value);
    }
  };

  handleBlur = () => {
    this.props.onBlur([this.props.name], true);
  };

  render() {
    const { name, options, value, placeholder, isMulti, isDisabled } = this.props;
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: '#fff' }),
      option: (styles, { isDisabled, isFocused, isSelected }) => {
        return {
          ...styles,
          fontSize: '0.875rem',
          color: isDisabled ? null : isSelected ? 'white' : isFocused ? 'white' : null,
          backgroundColor: isDisabled
            ? null
            : isSelected
            ? '#1ba7ae'
            : isFocused
            ? '#1ba7ae9c'
            : null,

          ':active': {
            ...styles[':active'],
            backgroundColor: !isDisabled && (isSelected ? '#fff' : '#1ba7ae'),
          },
        };
      },
    };

    let valuesList = null;
    if (isMulti) {
      valuesList = value ? options.filter(option => value.indexOf(option.value) >= 0) : [];
    } else {
      valuesList = options.find(option => option.value === value);
    }
    return (
      <Select
        name={name}
        isMulti={isMulti}
        className="custom-select-container"
        classNamePrefix="custom-select"
        options={options}
        value={valuesList}
        placeholder={placeholder}
        onChange={this.handleChange}
        styles={colourStyles}
        isClearable={true}
        isDisabled={isDisabled ? true : false}
      />
    );
  }
}
